import React from 'react';

import SearchResult from './SearchResult';
import './search.css';

const SearchComponent = ({
  hasFocus,
  query = '',
  onSearchInputChange,
  onSearchSubmit,
  onFocus,
  onBlur,
  extraClasses = '',
} = {}) => (
  <div
    className={`o-search mb3 ${
      hasFocus ? 'o-search-focus' : ''
    } ${extraClasses}`}
    onFocus={onFocus}>
    <button
      tabIndex={2}
      onClick={onBlur}
      className="a-search-exit u-show-on-focus u-scale-on-hover u-smooth-transitions">
      <svg id="icon-cross" viewBox="0 0 24 24" width="100%" height="100%">
        <title>cross</title>
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
      </svg>
    </button>

    <form onSubmit={onSearchSubmit} className="m-search-form">
      <input
        className="input-reset m-search-input"
        type="search"
        tabIndex={1}
        name="query"
        placeholder={hasFocus ? '' : 'Søk'}
        onChange={onSearchInputChange}
        value={query}
      />
      <i className="fa fa-search a-search-icon"></i>
      <SearchResult onClick={onBlur} query={query} />
    </form>
  </div>
);

export default SearchComponent;



// WEBPACK FOOTER //
// ./src/components/SearchComponent.js